import { useState, useRef, useEffect } from 'react';

function PreviewLinksMenu({ 
    previewUrls
}) {
    const [ isOpen, setIsOpen ] = useState( false );
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div ref={wrapperRef} style={{ position: 'relative', display: 'inline-block' }}>
            <button
                className="button primary-action"
                onClick={() => setIsOpen(prev => !prev)}
            >
                Preview
            </button>

            {isOpen && (
                <ul className="preview-dropdown">
                    {previewUrls.map((preview, index) => (
                        <li key={index}>
                            <a
                                href={preview.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Preview on <em>"{preview.related_shop.nickname}"</em> | Version {preview.related_version_id}
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default PreviewLinksMenu;